import Header from "../../blocks/header/header";
import Footer from "../../blocks/footer/footer";

const LayoutBase = ({ children }) => {
	return (
		<div>
			<Header />

			<main className="main">{children}</main>

			<Footer />
		</div>
	);
};

export default LayoutBase;
